<template>
  <v-dialog :value="value" max-width="500" content-class="glass-dialog-wrapper" @input="$emit('input', $event)">
    <v-card class="glass-card-contact elevation-24 overflow-hidden">
      <div class="relative pa-6 pb-4" :style="headerStyle">
        <div class="absolute-overlay"></div>
        <div class="d-flex align-center relative z-index-2 justify-space-between">
          <div class="d-flex align-center">
            <v-avatar size="60" class="elevation-5 border-white mr-4" :style="`border-color: ${color} !important`">
              <img :src="userImage" style="object-fit: cover" />
            </v-avatar>
            <div>
              <div class="text-overline white--text opacity-70 mb-0 line-height-1">Kontaktieren</div>
              <h3 class="text-h5 font-weight-black white--text text-shadow">{{ user ? user.vorname : "" }} {{ user ? user.nachname : "" }}</h3>
            </div>
          </div>
          <v-btn icon color="white" class="glass-btn" @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>

      <v-card-text class="pt-4 pb-6 px-6">
        <div class="d-flex gap-3 mb-6">
          <a :href="`tel:${user?.phone || user?.telefon || ''}`" class="text-decoration-none flex-grow-1">
            <div class="glass-panel-action pa-4 rounded-lg d-flex flex-column align-center justify-center hover-scale cursor-pointer h-100">
              <v-icon color="#00E676" large class="mb-2">mdi-phone</v-icon>
              <div class="white--text font-weight-bold">Anrufen</div>
              <div class="caption grey--text text-truncate" style="max-width: 100%">{{ user?.phone || user?.telefon || "N/A" }}</div>
            </div>
          </a>

          <a :href="`mailto:${user?.email || ''}`" class="text-decoration-none flex-grow-1">
            <div class="glass-panel-action pa-4 rounded-lg d-flex flex-column align-center justify-center hover-scale cursor-pointer h-100">
              <v-icon color="#29B6F6" large class="mb-2">mdi-email</v-icon>
              <div class="white--text font-weight-bold">E-Mail</div>
              <div class="caption grey--text text-truncate" style="max-width: 100%">{{ user?.email || "N/A" }}</div>
            </div>
          </a>
        </div>

        <v-divider class="mb-6 border-light"></v-divider>

        <div>
          <div class="d-flex align-center mb-4">
            <v-icon :color="color" class="mr-2">mdi-bell-ring</v-icon>
            <span class="text-h6 font-weight-bold white--text">Push Nachricht senden</span>
          </div>

          <div class="glass-form-wrapper pa-4 rounded-lg" :style="`border-color: ${hexToRgba(color, 0.3)}`">
            <v-text-field
              v-model="pushTitle"
              label="Titel"
              outlined
              dense
              dark
              hide-details
              class="mb-3 rounded-lg glass-input"
              placeholder="z.B. Terminänderung"
              :color="color"></v-text-field>

            <v-textarea
              v-model="pushMessage"
              label="Nachricht"
              outlined
              dense
              dark
              hide-details
              rows="3"
              class="mb-4 rounded-lg glass-input"
              placeholder="Deine Nachricht an den Kunden..."
              :color="color"></v-textarea>

            <v-btn
              block
              large
              depressed
              :color="color"
              class="white--text font-weight-bold rounded-lg glow-button"
              :loading="sending"
              :disabled="!pushTitle || !pushMessage"
              @click="sendPush">
              <v-icon left>mdi-send</v-icon> Senden
            </v-btn>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import api from "@/api"

export default {
  name: "UserContactDialog",
  props: {
    value: Boolean,
    user: {
      type: Object,
      default: () => ({}),
    },
    // NEU: Farbe konfigurierbar, Default ist dein Grün
    color: {
      type: String,
      default: "#00963f",
    },
  },
  data() {
    return {
      pushTitle: "",
      pushMessage: "",
      sending: false,
    }
  },
  computed: {
    userImage() {
      if (!this.user) return "/img/icons/user_placeholder.png"
      if (this.user.bild?.includes("uploads")) return "/img/profilbilder/" + this.user.bild
      if (this.user.bild) return "data:image/jpeg;base64," + this.user.bild
      return "/img/icons/user_placeholder.png"
    },
    // Dynamischer Header Hintergrund
    headerStyle() {
      return {
        background: `radial-gradient(circle at top right, ${this.hexToRgba(this.color, 0.4)} 0%, transparent 70%)`,
        borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
      }
    },
  },
  created() {
    console.log(this.user)
  },
  methods: {
    // Helper für Transparenz (wichtig für den Glass-Effekt)
    hexToRgba(hex, alpha) {
      if (!hex) return `rgba(0, 150, 63, ${alpha})`
      let c = hex.substring(1).split("")
      if (c.length == 3) c = [c[0], c[0], c[1], c[1], c[2], c[2]]
      c = "0x" + c.join("")
      return "rgba(" + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(",") + "," + alpha + ")"
    },
    close() {
      this.$emit("input", false)
      setTimeout(() => {
        this.pushTitle = ""
        this.pushMessage = ""
      }, 300)
    },
    async sendPush() {
      if (!this.user || !this.user._id) return

      this.sending = true
      try {
        await api.sendPushToUser({
          pushTitle: this.pushTitle,
          pushText: this.pushMessage,
          user: this.user._id,
          link: "/dashboard",
        })

        this.$toast.success("Push Benachrichtigung gesendet!")
        this.close()
      } catch (e) {
        console.error(e)
        this.$toast.error("Fehler beim Senden")
      } finally {
        this.sending = false
      }
    },
  },
}
</script>

<style scoped>
.glass-dialog-wrapper {
  box-shadow: none;
}
.glass-card-contact {
  background: #121212 !important;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
}
.absolute-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  /* Optional: Ein leichter dunkler Verlauf von unten nach oben im Header */
  background: linear-gradient(to top, #121212 0%, transparent 100%);
}
.border-white {
  border: 2px solid rgba(255, 255, 255, 0.8) !important;
}
.text-shadow {
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
}

.glass-panel-action {
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  transition: 0.2s;
}
.glass-panel-action:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.3);
}
.hover-scale:hover {
  transform: scale(1.02);
}

.glass-form-wrapper {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid; /* Color comes from inline style */
}
.glass-input >>> .v-input__slot {
  background: rgba(0, 0, 0, 0.3) !important;
}
/* WICHTIG für Darkmode Text in Inputs */
.glass-input >>> input,
.glass-input >>> textarea {
  color: white !important;
}

.glow-button {
  /* Shadow passt sich der Button Farbe an */
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.3);
}
.border-light {
  border-color: rgba(255, 255, 255, 0.1) !important;
}
.gap-3 {
  gap: 12px;
}
.cursor-pointer {
  cursor: pointer;
}
.h-100 {
  height: 100%;
}
.glass-btn {
  background: rgba(255, 255, 255, 0.1);
}
</style>
